import React from 'react';
import { Button } from './ui/Button';
import { Check, ShieldCheck, FileText } from 'lucide-react';
import { ImageCarousel } from './ImageCarousel';
const CAROUSEL_IMAGES = ['https://cdn.magicpatterns.com/uploads/uKgJxAkaFKJ4K94ZZ2v96Z/UPSELL_TEORIA_DE_LAS_ORGANIZACIONES.png', 'https://cdn.magicpatterns.com/uploads/qeNBExxYGDndstG8A8kByM/ChatGPT_Image_11_ene_2026,_07_34_47_p.m..png', 'https://cdn.magicpatterns.com/uploads/93W4eyfWaSf72gKumbz3bo/COVER_TDLO360.png'];
export function UpsellSection() {
  return <section className="py-12 px-4 bg-gradient-to-b from-blue-900 to-blue-800 text-white relative overflow-hidden" data-id="element-370">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-371"></div>

      {/* Premium Badge */}
      <div className="max-w-md mx-auto relative z-10 mb-8 text-center" data-id="element-372">
        <div className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-500 text-blue-900 px-6 py-2 rounded-full font-black text-lg uppercase tracking-wide shadow-xl" data-id="element-373">
          🏆 OFERTA PREMIUM
        </div>
        <h2 className="text-2xl md:text-3xl font-bold mt-4 mb-2" data-id="element-374">
          ¡Llevate el Pack Completo!
        </h2>
        <p className="text-blue-200" data-id="element-375">
          Todo lo que necesitás para el año + Proyecto Integrador Real
        </p>
      </div>

      <div className="max-w-md mx-auto relative z-10" data-id="element-376">
        <div className="bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden border-4 border-yellow-500" data-id="element-377">
          {/* Carousel Section */}
          <div className="bg-gradient-to-b from-gray-50 to-white p-6" data-id="element-378">
            <ImageCarousel images={CAROUSEL_IMAGES} data-id="element-379" />
          </div>

          {/* Price Section */}
          <div className="px-6 py-8 text-center border-b border-gray-100" data-id="element-380">
            <p className="text-gray-400 text-sm font-semibold uppercase tracking-wider mb-2" data-id="element-381">
              Precio Final Pack Premium
            </p>
            <div className="mb-2" data-id="element-382">
              <span className="text-gray-400 text-2xl line-through" data-id="element-383">
                $59.990
              </span>
            </div>
            <div className="text-blue-900 font-black text-5xl mb-3" data-id="element-384">
              $26.990
            </div>
            <div className="inline-block bg-green-100 text-green-700 px-4 py-1 rounded-full text-sm font-bold" data-id="element-385">
              Ahorrás 55% HOY
            </div>
          </div>

          {/* Features Section */}
          <div className="px-6 py-6 space-y-4" data-id="element-386">
            {/* Feature 1 - Green */}
            <div className="bg-green-50 border border-green-200 rounded-xl p-4 flex gap-3" data-id="element-387">
              <div className="flex-shrink-0 mt-1" data-id="element-388">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-389">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-390" />
                </div>
              </div>
              <div data-id="element-391">
                <h4 className="font-bold text-gray-900 mb-1 text-sm leading-tight" data-id="element-392">
                  TEORIA DE LAS ORGANIZACIONES 360 + PROYECTO INTEGRADOR EMPRESA
                  REAL DE BARRIO + 100 MICRO-EMPRENDIMIENTOS GANADORES
                </h4>
                <p className="text-sm text-gray-600" data-id="element-393">
                  El pack completo con todo el contenido del año + material
                  exclusivo para proyectos finales
                </p>
              </div>
            </div>

            {/* Feature 2 - Yellow */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 flex gap-3" data-id="element-394">
              <div className="flex-shrink-0 mt-1" data-id="element-395">
                <div className="w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center" data-id="element-396">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-397" />
                </div>
              </div>
              <div data-id="element-398">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-399">
                  2 Bonos Exclusivos (Gratis por hoy)
                </h4>
                <p className="text-sm text-gray-600" data-id="element-400">
                  Banco de actividades rápidas y pack completo de evaluaciones
                  listas
                </p>
              </div>
            </div>

            {/* Feature 3 - Blue */}
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 flex gap-3" data-id="element-401">
              <div className="flex-shrink-0 mt-1" data-id="element-402">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center" data-id="element-403">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-404" />
                </div>
              </div>
              <div data-id="element-405">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-406">
                  Acceso Inmediato y Vitalicio
                </h4>
                <p className="text-sm text-gray-600" data-id="element-407">
                  Descargá todo el material al instante y accedé cuando lo
                  necesites, sin vencimiento
                </p>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="px-6 pb-6" data-id="element-408">
            <Button href="https://checkout.rincondigital.shop/cart/52931301671187:1" variant="primary" size="lg" fullWidth withArrow className="shadow-xl shadow-yellow-500/30 text-lg py-5 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600" data-id="element-409">
              QUIERO EL PACK PREMIUM COMPLETO
            </Button>
          </div>

          {/* Trust Badges */}
          <div className="px-6 pb-6 flex items-center justify-center gap-6 text-sm text-gray-500" data-id="element-410">
            <div className="flex items-center gap-2" data-id="element-411">
              <ShieldCheck className="h-4 w-4 text-green-500" data-id="element-412" />
              <span data-id="element-413">Compra Segura</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-414">
              <FileText className="h-4 w-4 text-blue-500" data-id="element-415" />
              <span data-id="element-416">Material Digital</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}